import { Alert, Button, Modal, Table } from "antd"
import { useGetDataMappingJobsQuery } from "../../../api/dataMapping/dataMappingApi"
import { formatDateTimeISO } from "../../../utils/date";

const columns = [
  {
    title: "Job ID",
    dataIndex: "JobId",
    key: "JobId",
  },
  {
    title: "Processed Started At",
    dataIndex: "ProcessedStartedAt",
    key: "ProcessedStartedAt",
    render: (v: string) => v ? formatDateTimeISO(v) : "-"
  },
  {
    title: "Processed Finished At",
    dataIndex: "ProcessedFinishedAt",
    key: "ProcessedFinishedAt",
    render: (v: string) => v ? formatDateTimeISO(v) : "-"
  },
  {
    title: "Ingested Rows",
    dataIndex: "IngestedRows",
    key: "IngestedRows",
  },
  // {
  //   title: "Error Rows",
  //   dataIndex: "ErrorRows",
  //   key: "ErrorRows",
  // },
  {
    title: "Error Count",
    dataIndex: "Errors",
    key: "Errors",
    render: (v?: string[]) => v ? v.length : "-"
  },
  {
    title: "Status",
    dataIndex: "Status",
    key: "Status",
  },
  {
    title: "Action",
    key: "action",
    render: (_: any, obj: any) => {
      function onClickViewErr() {
        Modal.confirm({
          content: obj.Errors!!.map((err: string) => <li>{err}</li>),
          width: 800
        })
      }
      return (
        <Button
          disabled={obj.Errors == null || obj.Errors.length === 0}
          onClick={onClickViewErr}
        >
          View Errors
        </Button>
      )
    }
  }

]

export default function UploadJobTable() {
  const { data, error, isFetching, refetch } = useGetDataMappingJobsQuery();

  const sData = data?.Items?.toSorted((a, b) =>
    b.ProcessedStartedAt.localeCompare(a.ProcessedStartedAt));
  return (
    <>
    <Button onClick={refetch} type="primary">Reload</Button>
    { error && <Alert type="error" message="Error loading data" /> }
    <Table
      loading={isFetching}
      dataSource={sData}
      columns={columns}
    />
    </>
  )
}
